import axios from "axios";

let url = "https://admin.techqilla.com/api/";

if (process.env.NODE_ENV === "development") {
  url = "https://admin.techqilla.com/api/";
}

export const axiosApi = axios.create({
  baseURL: url,
});
